// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.llm-query-container[data-v-aa6a174e] {\n    margin-top: 20px;\n    background-color: #f5f5f5;\n    padding: 15px;\n    border-radius: 5px;\n}\n.llm-query-ui-container[data-v-aa6a174e] {\n    text-align: center;\n}\n.llm-query-contents-container[data-v-aa6a174e] {\n    vertical-align: bottom;\n    padding: 15px;\n}\n.search-focus-input[data-v-aa6a174e] {\n    width: 25% !important;\n    display: inline-block;\n    margin: 0 15px 0 7px;\n}\n", ""]);
// Exports
module.exports = exports;
